<template>
<div class="contentGlobal">
    <div class="content inner">
        <div class="int pTop" v-if="pool">
            <b-container fluid id="carousel1">
                <div class="slider w100">
                    <pool-global :pool="pool" :mode="mode"></pool-global>
                </div>
          </b-container>
        </div>
        <div v-if="error">
            <b-alert show variant="warning"><md-icon>info</md-icon> {{ $t("messages.poolNotExist") }}  </b-alert> 
        </div>
    </div>
</div>

</template>

<script>
import { mapState} from 'vuex'
import PoolGlobal from "./Pool";
const fb = require('../firebaseConfig.js')

export default {
    name: 'detail',
    components: {
        PoolGlobal
    },
    data() {
        return {
            pool: null,
            error: false,
            firstLoad:false,
            mode: "slide",
            timeout: null
        }
    },
    created(){
         this.$nextTick(() => {
            this.getPool();
         })
    },
    computed: {
        ...mapState(['userProfile', 'userNotPresent']),

    },
    watch: {
        'pool': {
            handler(value) {
             if(value && value != null && !this.firstLoad){
               this.$store.commit('getWeather', this.pool)
               this.$store.dispatch('prepareSend', this.pool)
               this.firstLoad = true
             }
            },
        },
        'userNotPresent': function() {
            if(!this.userNotPresent && this.pool){
                this.$store.dispatch('prepareSend', this.pool)
            }
        }
    },
    methods: {
        getPool(){
            let id = this.$route.params.poolId.toUpperCase();
            //check if pool is in user list 
            var _pool = this.$store.getters.getPoolById(id);
            if(_pool && _pool.id != null){
                this.pool = _pool;
            }else{
                fb.poolsCollection.where('id', '==',id).onSnapshot(res => {
                res.forEach(doc => {
                    if(doc.exists){
                        this.pool = doc.data();
                    }
                })}, err => {
                    this.error = true
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Detail.vue